import { DatePicker, Divider, Card, Modal } from "antd";
import { IoMdAdd } from "react-icons/io";
import "./bank-screen.scss";
import Button from "src/libraries/components/button/Button";
import { useState } from "react";
import { BankAdapter } from "./bank-adapter";
import CreateModal from "src/libraries/components/create-modal/create-modal";
import { DetailBankScreen } from "./detail-bank-screen";
import { Pagination, Empty } from "antd";
import LoadingSpinnerScreen from "src/libraries/components/loading-spinner/loading-spinner.screen";
import { BankAccount } from "src/libraries/types/bank";
export const BankScreen = () => {
  const [isOpenDetailScreen, setIsOpenDetailScreen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<number>(0);
  //const displayData: BankAccount[] = [];
  const {
    loading,
    totalItem,
    currentPage,
    onPageChange,
    isModalVisible,
    isStepOneCompleted,
    showModal,
    handleOk,
    handleCancel,
    handleChange,
    displayData,
    isOpenDetailBankScreen,
    setIsOpenDetailBankScreen,
  } = BankAdapter();
  const handleDetail = (key: string) => {
    console.log(key);
    setSelectedItem(parseInt(key));
    setIsOpenDetailBankScreen(true);
  };
  const handleCancelDetailScreen = () => {
    setSelectedItem(0);
    setIsOpenDetailBankScreen(false);
  };
  const fields = [
    // {
    //   name: "terminalId",
    //   type: "text",
    //   label: "Tên terminal",
    //   placeholder: "Tên terminal",
    //   rules: {
    //     required: "Bắt buộc",
    //     // pattern: {
    //     //   value: /^[0-9]{9,13}$/,
    //     //   message: "Vui lòng nhập số tài khoản từ 9 đến 13 số",
    //     // },
    //   },
    // },
    {
      name: "bankAccountName",
      type: "text",
      label: "Tên tài khoản ",
      placeholder: "Tên tài khoản (in hoa và không dấu)",
      rules: {
        required: "Bắt buộc",
        pattern: {
          value: /^[A-Z\s]+$/,
          message: "Vui lòng nhập Tên in hoa và không dấu",
        },
      },
    },
    {
      name: "bankAccountNumber",
      type: "text",
      label: "Số tài khoản",
      placeholder: "Số tài khoản",
      rules: {
        required: "Bắt buộc",
        // pattern: {
        //   value: /^[0-9]{9,13}$/,
        //   message: "Vui lòng nhập số tài khoản từ 9 đến 13 số",
        // },
      },
    },

    {
      name: "identityNumber",
      type: "text",
      label: "Số CMT/CCCD/MST",
      placeholder: "Số CMT/CCCD/MST (ứng với tài khoản ngân hàng)",
      rules: {
        required: "Bắt buộc",
        pattern: {
          value: /^[0-9]{12}$/,
          message: "Số CMT/CCCD/MST không hợp lệ",
        },
      },
    },
    {
      name: "phoneNumber",
      type: "text",
      label: "Số điện thoại",
      placeholder: "Số điện thoại (ứng với tài khoản đăng ký ngân hàng)",
      rules: {
        required: "Bắt buộc",
        pattern: {
          value: /^[0-9]{10}$/,
          message: "Số điện thoại không hợp lệ",
        },
      },
    },
  ];
  return (
    <div>
      {loading ? (
        <LoadingSpinnerScreen className="big" />
      ) : (
        <div>
          {!isOpenDetailBankScreen && (
            <div className="bank-screen">
              <div className="add-bank">
                <Button
                  className="add-button"
                  background="#022e45"
                  textColor="#FFF"
                  borderColor="#022e45"
                >
                  <div className="button-content" onClick={() => showModal()}>
                    <i>
                      <IoMdAdd color="#fff" size={24} />
                    </i>
                    <p className="button-text">Thêm tài khoản</p>
                  </div>
                </Button>
              </div>
              {displayData && displayData.length === 0 ? (
                <Empty />
              ) : (
                <div>
                  <div className="account-container">
                    {displayData &&
                      Object.entries(displayData).map(([key, value]) => (
                        <Card
                          onClick={() => handleDetail(key)}
                          hoverable
                          className="account-card"
                          key={key}
                        >
                          <div className="account-item">
                            <div className="account-img">
                              <img
                                alt="Bank logo"
                                loading="lazy"
                                src="https://img.bankhub.dev/rounded/mbbank.png"
                              />
                            </div>
                            <div className="account-name">
                              <div className="account-merchant">
                                {value.bankAccountName}
                              </div>
                              <div className="account-id">
                                {value.bankAccountNumber}
                              </div>
                            </div>
                            <div className="account-state">
                              <div>Đang liên kết</div>
                            </div>
                          </div>
                        </Card>
                      ))}
                  </div>
                  <div className="account-pagination">
                    <Pagination
                      onChange={onPageChange}
                      align="end"
                      pageSize={4}
                      current={currentPage}
                      total={totalItem}
                      responsive
                    />
                  </div>
                </div>
              )}
              <CreateModal
                title="Thêm mới tài khoản"
                isModalVisible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                onChange={handleChange}
                fields={fields}
                isStepOneCompleted={isStepOneCompleted}
              />
            </div>
          )}
        </div>
      )}

      {isOpenDetailBankScreen && (
        <DetailBankScreen
          handleCancel={handleCancelDetailScreen}
          data={displayData[selectedItem]}
        />
      )}
    </div>
  );
};
